import React from 'react';
import { Outlet } from 'react-router-dom';

function SalesDeveloperLayout() {
  return <Outlet />;
}

export default SalesDeveloperLayout;
